import React from 'react'
import { Typography, Box } from '@mui/material'
import HelperText from '@mui/material/FormHelperText'
import saveCard from '../../../../assets/save_card.png'
import { PhoneNumberInput } from './PhoneNumberInput'

type CreditDebitComponentProps = {
  setPhoneNumber: React.Dispatch<React.SetStateAction<string | undefined>>
  phoneNumberError: () => boolean
  setCountryPhoneCode: React.Dispatch<React.SetStateAction<string | undefined>>
}

export function CreditDebitComponent({
  setPhoneNumber,
  phoneNumberError,
  setCountryPhoneCode,
}: Readonly<CreditDebitComponentProps>) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        width="100%"
        mb={2}>
        <Typography variant="h6" fontWeight="bold" color="#4D4D4D">
          TnG eWallet or
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="#4D4D4D">
          Credit/Debit Card
        </Typography>
      </Box>

      <Box width="100%" display="flex" flexDirection="column" gap={2} mb={2}>
        <Typography variant="body1">
          Enter the phone number linked with your TnG eWallet or card account to
          proceed.
        </Typography>
        <Typography variant="body1">
          If you choose card, please make sure to tick this box on the next page
          to enable payment linking
        </Typography>
        <Box>
          <img src={saveCard} alt="Save Card" width={265} height={50} />
        </Box>
        <Typography variant="body1">
          Note that a RM1.00 nominal fee will be charged (and refunded) for
          authentication purpose.
        </Typography>
      </Box>

      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="flex-start">
        <PhoneNumberInput
          setCountryPhoneCode={setCountryPhoneCode}
          setPhoneNumber={setPhoneNumber}
        />
        {phoneNumberError() && (
          <HelperText error>Invalid Phone Number</HelperText>
        )}
      </Box>
    </Box>
  )
}
